import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/client'
import { CloseOutlined, DownOutlined } from '@ant-design/icons'
import { Dropdown } from 'antd'
import { Input, Button } from 'ui/styled'
import { flattenGraphQLEdges } from 'utils/helpers'
import NAVIGATOR_NOTES_SAMPLES from 'apollo/queries/NAVIGATOR_NOTES_SAMPLES'
import useNavigatorNoteSampleDestroy from 'apollo/mutations/NAVIGATOR_NOTES_SAMPLE_DESTROY'
import useNavigatorNoteSampleUpsert from 'apollo/mutations/NAVIGATOR_NOTES_SAMPLE_UPSERT'
import { Templates, MenuItem } from './styled'

const NoteTemplates = ({ intro, onTemplateSelect }) => {
  const [showSaving, setShowSaving] = useState(false)
  const [saveAs, setSaveAs] = useState('')
  const { onNavigatorNoteSampleDestroy } = useNavigatorNoteSampleDestroy()
  const { onNavigatorNoteSampleUpsert } = useNavigatorNoteSampleUpsert()

  const { data, loading, refetch } = useQuery(NAVIGATOR_NOTES_SAMPLES)
  const templates = flattenGraphQLEdges(data, 'navigator_note_samples')

  const removeTemplate = async (e, id) => {
    e.preventDefault()
    e.stopPropagation()
    await onNavigatorNoteSampleDestroy({
      id
    })
    refetch()
  }

  const saveTemplate = async () => {
    if (!saveAs) return false
    await onNavigatorNoteSampleUpsert({
      attributes: {
        name: saveAs,
        note: intro
      }
    })
    setShowSaving(false)
    refetch()
  }

  const menuItems = loading
    ? [{ key: 'loading', label: 'Loading...', disabled: true }]
    : templates.length > 0
    ? templates.map(template => ({
        key: template.id,
        label: (
          <MenuItem>
            <span className="item_text">{template.name || template.note}</span>
            <CloseOutlined
              className="dropdown_icon"
              onClick={e => removeTemplate(e, template.id)}
            />
          </MenuItem>
        ),
        onClick: () => onTemplateSelect(template.note)
      }))
    : [{ key: 'empty', label: 'No templates', disabled: true }]

  if (showSaving)
    return (
      <Templates>
        <Input
          autoFocus
          placeholder="Template name"
          onChange={e => setSaveAs(e.target.value)}
          data-test="carePlanBuilderTemplateNameInput"
          margin="0 0 10px"
        />
        <Button
          btntype="link"
          data-test="saveTemplateBtn"
          onClick={saveTemplate}
        >
          Save
        </Button>
        <Button
          btntype="link"
          data-test="cancelTemplateBtn"
          onClick={() => setShowSaving(false)}
        >
          Cancel
        </Button>
      </Templates>
    )
  return (
    <Templates>
      <Dropdown menu={{ items: menuItems }} disabled={!templates.length}>
        <div onClickCapture={e => e.stopPropagation()}>
          <Button data-test="loadTemplateBtn" loading={loading}>
            Load template <DownOutlined />
          </Button>
        </div>
      </Dropdown>
      <Button
        btntype="link"
        data-test="saveTemplateAsBtn"
        onClick={() => setShowSaving(true)}
      >
        Save Current Text as Template...
      </Button>
    </Templates>
  )
}

NoteTemplates.propTypes = {
  onTemplateSelect: PropTypes.func.isRequired,
  intro: PropTypes.string.isRequired
}

export default NoteTemplates
